<template>
  <div
    :class="{ 'col': true, 'q-mt-xs': compact && !showtimesGridButtonUseButtonDrawer }"
    data-test-id="showtimes-button-compact"
  >
    <q-btn
      v-bind="$attrs"
      :push="!showtimesGridButtonUseButtonDrawer && buttonType !== BUTTON_TYPES.UNELEVATED"
      :color="getButtonColor"
      :outline="buttonType === BUTTON_TYPES.OUTLINE"
      :flat="buttonType === BUTTON_TYPES.FLAT"
      :unelevated="buttonType === BUTTON_TYPES.UNELEVATED"
      :text-color="getTextColor"
      size="md"
      :align="buttonAlign"
      class="showing text-weight-bold text-body1 row"
      style="position: relative;"
      :style="{
        width: buttonWidth,
        'border-bottom': showtimesGridButtonUseButtonDrawer ? '2px solid rgba(0, 0, 0, 0.1)' : undefined,
        'border-radius': showtimesGridButtonUseButtonDrawer ? undefined : `${borderRadius}px`,
        'pointer-events': salesEnabled ? undefined : 'none',
        'min-height': compact ? '40px' : undefined,
        'background-color': getBackgroundColorHex,
        color: getTextColorHex
      }"
      :class="{
        past: showing.localPast,
        current: showing.current,
        'q-py-lg': isMoviePage,
        'q-py-md': !isMoviePage && !showtimesGridButtonUseButtonDrawer && !compact,
        'q-py-sm': showtimesGridButtonUseButtonDrawer && compact,
        'items-center': !showtimesGridButtonUseButtonDrawer,
        'inset-shadow': addInsetShadow,
        [showing.displayMetaData && showing.displayMetaData.classes]: true,
        'q-px-none': !showtimesGridButtonUseButtonDrawer,
        'q-px-sm': showtimesGridButtonUseButtonDrawer
      }"
      :disable="isDisabled"
      :data-test-id="`showtimes-button-compact-${isDisabled ? 'disabled' : 'enabled'}`"
      @click="$emit('select-showing', showing)"
      @contextmenu.prevent="$emit('show-held-seat-dialog')"
    >
      {{ $d(showing.movieSiteTime, 'shortTime') }}

      <showing-badge
        v-for="showingBadge in distinctShowingBadgesNoneTitleDisplay"
        :key="showingBadge.id"
        class="col-auto q-pl-none q-pr-none q-mr-none bg-transparent"
        :solid="solidShowingBadges"
        size="sm"
        :force-icon="distinctShowingBadgesNoneTitleDisplay.length > 1 || (isShowtimeGrid && !isMoviePage && !showtimesGridButtonUseButtonDrawer)"
        :badge-name-max-width="isShowingButton ? '60px' : undefined"
        dense
        :showing-badge="showingBadge"
        :color="getIconColor"
      />
      <q-chip
        v-if="currentSite.showConsumerAttendanceBadge && showAttendanceLevels && (showing.predictedAttendance < 7 || showing.predictedAttendance > 20)"
        square
        color="transparent"
        size="xs"
        text-color="white"
        icon="people"
        class="col-auto q-px-xs"
      >
        <q-tooltip
          class="text-white"
          style="background-color: rgba(0, 0, 0, 0.5)"
        >
          {{ showing.predictedAttendance > 20 ?
            ('We are projecting a high turn out for this showing! Suggest arriving ' + Math.round(Math.max(showing.predictedAttendance / 3, 10)) + ' minutes before the start time.') :
            'Low projected attendance level, this is a great show to attend, beat the crowds!'
          }}
        </q-tooltip>
      </q-chip>
      <q-chip
        v-if="showing.isSoldOut"
        square
        align="center"
        color="negative"
        size="xs"
        text-color="white"
        :dense="compact"
        :class="showtimesGridButtonUseButtonDrawer ? undefined : 'absolute'"
        :style="showtimesGridButtonUseButtonDrawer ? undefined : 'top: -10px; left: 5px; z-index: 1;'"
      >
        {{ $t('status.soldOutShort') }}
      </q-chip>
      <q-chip
        v-if="showing.isNearCapacity && !showing.isSoldOut "
        square
        align="center"
        color="warning"
        text-color="negative"
        size="xs"
        :dense="compact"
        :class="showtimesGridButtonUseButtonDrawer ? undefined : 'absolute'"
        :style="showtimesGridButtonUseButtonDrawer ? 'margin-right: -6px' : 'top: -10px; left: 5px; z-index: 1;'"
      >
        <div
          class="text-center full-width"
        >
          {{ $tc('ticket.ticketsLeftCount', showing.seatsRemaining) }}
        </div>
      </q-chip>
    </q-btn>
    <div
      v-if="!$_.isEmpty(distinctShowingBadgesTitleDisplay)"
      class="row button-tagline-banner"
      :style=" {
        'border-bottom-left-radius': getBorderRadius,
        'border-bottom-right-radius': getBorderRadius,
        'padding-top': `${borderRadius}px`,
        'padding-left': !!borderRadius && borderRadius > 12 ? `${borderRadius / 2}px` : undefined,
        'padding-right': !!borderRadius && borderRadius > 12 ? `${borderRadius / 2}px` : undefined,
        'margin-top': `-${borderRadius}px`,
        'border-color': !!getButtonColor ? `var(--q-${getButtonColor})` : getBackgroundColorHex,
        width: buttonWidth,
      }"
    >
      <showing-badge
        v-for="showingBadge in distinctShowingBadgesTitleDisplay"
        :key="showingBadge.id"
        class="transparent q-pa-none inline-block"
        size="sm"
        dense
        :showing-badge="showingBadge"
        :color="isShowtimesDarkMode && !isMoviePage ? 'grey-1' : 'responsive-grey-9'"
        text-left
        display-title-on-button
      />
      <q-tooltip
        v-if="isDisabled"
      >
        {{ buttonDisabledMessage }}
      </q-tooltip>
    </div>
  </div>
</template>
<script>

import { BUTTON_TYPES } from 'src/models/page/Section'
import Showing from 'src/models/showing/Showing'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'

export default {
  name: 'ShowtimesButtonCompact',
  components: {
    ShowingBadge
  },
  props: {
    showing: {
      type: Showing,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    showAttendanceLevels: {
      type: Boolean,
      required: false,
      default: false
    },
    solidShowingBadges: {
      type: Boolean,
      required: false,
      default: false
    },
    distinctShowingBadges: {
      type: Array,
      required: false,
      default: () => []
    },
    isShowtimeGrid: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 3
    },
    showtimesGridButtonUseButtonDrawer: {
      type: Boolean,
      required: false,
      default: false
    },
    isMoviePage: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonType: {
      type: String,
      required: false,
      default: BUTTON_TYPES.UNELEVATED
    },
    buttonColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    buttonColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    addInsetShadow: {
      type: Boolean,
      required: false,
      default: false
    },
    isShowingButton: {
      type: Boolean,
      required: false,
      default: false
    },
    isShowtimesDarkMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  configuration: ['currentSite'],
  emits: ['select-showing', 'show-held-seat-dialog'],
  computed: {
    filledButton () {
      return this.buttonType === BUTTON_TYPES.STANDARD || this.buttonType === BUTTON_TYPES.UNELEVATED
    },
    buttonWidth () {
      if (this.isMoviePage) {
        return this.$q.screen.lt.md ? '155px' : '172px'
      } else {
        return '100%'
      }
    },
    salesEnabled () {
      return this.currentSite.hasOnlineTicketing
    },
    showingBadgesHasCustomColor () {
      return _.some(this.distinctShowingBadges.map(showingBadge => !_.isNil(showingBadge.color)))
    },
    distinctShowingBadgesNoneTitleDisplay () {
      return _.filter(this.distinctShowingBadges, showingBadge => !showingBadge.displayTitleOnButton)
    },
    distinctShowingBadgesTitleDisplay () {
      return _.filter(this.distinctShowingBadges, showingBadge => !!showingBadge.displayTitleOnButton)
    },
    getShowingBadgeColor () {
      if (!this.showingBadgesHasCustomColor) return null

      const conferPriorityColors = _(this.distinctShowingBadges)
        .filter(showingBadge => showingBadge.conferPriority && !_.isNil(showingBadge.color))
        .map(showingBadge => showingBadge.color)
        .value()

      const colors = _(this.distinctShowingBadges)
        .filter(showingBadge => !_.isNil(showingBadge.color))
        .map(showingBadge => showingBadge.color)
        .value()

      return conferPriorityColors.length > 0 ? conferPriorityColors[0] : colors[0]
    },
    getButtonColor () {
      if (this.isDisabled) return 'grey-5'
      if (this.filledButton && !this.showingBadgesHasCustomColor && this.buttonColor !== 'custom') return this.buttonColor
      return undefined
    },
    getTextColor () {
      if (this.isDisabled) return 'grey'
      if (this.filledButton) {
        let colorHex
        if (this.getShowingBadgeColor) {
          colorHex = this.getShowingBadgeColor
        } else if (this.buttonColor === 'custom') {
          colorHex = this.buttonColorHex
        } else {
          colorHex = this.$getSiteColorHex(this.currentSite, this.buttonColor)
        }
        if (!colorHex) return false
        return this.$isColorDark(colorHex) ? 'white' : 'black'
      }
      if (!this.filledButton && this.buttonColor !== 'custom') return this.buttonColor
      return 'primary'
    },
    getIconColor () {
      if (this.isDisabled) return 'grey'
      if (this.filledButton) {
        let colorHex
        if (this.getShowingBadgeColor) {
          colorHex = this.getShowingBadgeColor
        } else if (this.buttonColor === 'custom') {
          colorHex = this.buttonColorHex
        } else {
          colorHex = this.$getSiteColorHex(this.currentSite, this.buttonColor)
        }
        if (!colorHex) return false
        return this.$isColorDark(colorHex) ? 'white' : 'black'
      } else {
        // For unfilled buttons: In dark mode, use white for icon visibility, so upload icon image will be filter to white color
        if (this.$q.dark.isActive) return 'white'
        return this.buttonColor === 'custom' ? this.buttonColorHex : this.buttonColor
      }
    },
    buttonDisabledMessage () {
      return this.showing.hasPurchaseEmbargo ? this.$t('showing.ticketsGoOnSale', { time: this.$d(this.showing.embargoPurchaseLiftedAt, 'medium') }) : this.$t('showing.noLongerAvailableForPurchaseOnline')
    },
    getBackgroundColorHex () {
      if (!this.filledButton) return undefined
      if (this.getShowingBadgeColor) {
        return this.getShowingBadgeColor
      } else {
        return this.buttonColor === 'custom' ? this.buttonColorHex : undefined
      }
    },
    getTextColorHex () {
      if (this.filledButton) return undefined
      if (this.getShowingBadgeColor) {
        if ((this.$isColorDark(this.getShowingBadgeColor) && this.$q.dark.isActive) || (!this.$isColorDark(this.getShowingBadgeColor) && !this.$q.dark.isActive)) return
        return this.getShowingBadgeColor
      } else {
        return this.buttonColor === 'custom' ? this.buttonColorHex : undefined
      }
    },
    buttonAlign () {
      return (this.distinctShowingBadgesNoneTitleDisplay?.length > 0 || (this.currentSite.showConsumerAttendanceBadge && this.showAttendanceLevels && (this.showing?.predictedAttendance < 7 || this.showing?.predictedAttendance > 20))) ? 'between' : 'center'
    },
    getBorderRadius () {
      return this.borderRadius ? `${this.borderRadius}px` : undefined
    }
  },
  created () {
    _.extend(this, { BUTTON_TYPES })
  },
  methods: {
    badgeSeparatorClass (index) {
      if (index === this.distinctShowingBadgesTitleDisplay.length - 1) return

      if (this.isMoviePage) {
        return this.$q.dark.isActive ? 'badge-separator-white' : 'badge-separator-dark'
      } else {
        return this.isShowtimesDarkMode ? 'badge-separator-white' : 'badge-separator-dark'
      }
    }
  }

}
</script>

<style lang="css" scoped>
.button-tagline-banner {
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  height: auto;
  margin-top: -4px;
  padding-bottom: 4px;
}
:deep(.button-tagline-banner > .q-chip:not(:last-child) .ellipsis-2-lines:after) {
  content: '•';
  margin-left: 2px;
  position: absolute;
}
</style>
